import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { OptionType, PromiseStatuses } from "../../../utils";
import { ProtocolloPre2015DataResponse, ProtocolloPre2015Filters, ProtocolloPre2015Response } from "./dataService/dto";
import { NewOldProtocolService } from "./dataService/service";

interface Pre2015State {
    // FILTERS
    idSelectedCert?: string
    oldProtocolResponse?: ProtocolloPre2015Response
    oldProtocolResponseById?: ProtocolloPre2015DataResponse
    oldProtocolResponseStatus: PromiseStatuses
    oldProtocolResponseByIdStatus: PromiseStatuses
    oldProtocolFilters: ProtocolloPre2015Filters
}

const initialState: Pre2015State = {
    oldProtocolResponseStatus: 'idle',
    oldProtocolResponseByIdStatus: 'idle',
    oldProtocolFilters: {
        customer: '',
        page: 0,
        itemsPerPage: 0
    }
}

export const GetAllOldProtocol = createAsyncThunk(
    'oldProtocol/GetAllOldProtocol',
    async (filters: ProtocolloPre2015Filters, thunkApi): Promise<ProtocolloPre2015Response> => {
        const oldProtService = NewOldProtocolService()
        return oldProtService.GetAllOldProtocols(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetOldProtocolById = createAsyncThunk(
    'oldProtocol/GetOldProtocolById',
    async (id: string, thunkApi): Promise<ProtocolloPre2015DataResponse> => {
        const oldProtService = NewOldProtocolService()

        return oldProtService.GetOldProtocolById(id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const Pre2015Slice = createSlice({
    name: 'pre2015/slice',
    initialState,
    reducers: {
        //FILTERS
        setGetAllFiltersCustomer: (state, action) => {
            state.oldProtocolFilters.customer = action.payload
        },
        setGetAllFiltersItemsPerPage: (state, action) => {
            state.oldProtocolFilters.itemsPerPage = action.payload
        },
        setGetAllFiltersPage: (state, action) => {
            state.oldProtocolFilters.page = action.payload
        },

        resetGetAllStatus: (state) => {
            state.oldProtocolResponseStatus = 'idle'
        },
        //reset status
        resetGetAllFilters: (state) => {
            state.oldProtocolFilters = {
                itemsPerPage: 0,
                page: 0,
                customer: '',
            }
        },

    },
    extraReducers(builder) {
        builder
            // GET ALL
            .addCase(GetAllOldProtocol.pending, (state) => {
                state.oldProtocolResponseStatus = 'loading'
            })
            .addCase(GetAllOldProtocol.fulfilled, (state, action) => {
                state.oldProtocolResponseStatus = 'successfully'
                state.oldProtocolResponse = action.payload
            })
            .addCase(GetAllOldProtocol.rejected, (state) => {
                state.oldProtocolResponseStatus = 'failed'
            })

            // GET by id
            .addCase(GetOldProtocolById.pending, (state) => {
                state.oldProtocolResponseByIdStatus = 'loading'
            })
            .addCase(GetOldProtocolById.fulfilled, (state, action) => {
                state.oldProtocolResponseByIdStatus = 'successfully'
                state.oldProtocolResponseById = action.payload
            })
            .addCase(GetOldProtocolById.rejected, (state) => {
                state.oldProtocolResponseByIdStatus = 'failed'
            })
    }
})

export const {
    setGetAllFiltersCustomer,
    setGetAllFiltersItemsPerPage,
    setGetAllFiltersPage,
    resetGetAllStatus,
    resetGetAllFilters
} = Pre2015Slice.actions

export default Pre2015Slice.reducer